import { API_BASE_URL } from "@/auth/LogtoConfig"

export function resolveAssetUrl(value?: string | null) {
  const src = value?.trim()
  if (!src) return undefined
  if (/^(https?:)?\/\//i.test(src) || src.startsWith("data:") || src.startsWith("blob:")) {
    return src
  }
  return `${API_BASE_URL}${src.startsWith("/") ? src : `/${src}`}`
}
